import {
    CAT_LIST, GET_CAT, GET_INV, GET_SUBCAT_BY_CAT_ID, INVENTORY_LIST
} from '../actions/types';
const initialState: any = {
    inventories: [],
    inventory:{}
};
const InventoryReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case INVENTORY_LIST:
            return {
                ...state,
                inventories: action.payload
            };
        case GET_INV:
            return {
                ...state,
                inventory: action.payload
            };   
        default:
            return state;
    }
};
export default InventoryReducer;